import component from "./Videos";
export default component;
